import React									from 'react';
import {NavigateFunction}						from 'react-router-dom';
import {Dispatch}								from '@reduxjs/toolkit';

import {NotificationText, NotificationsType}	from '../../redux/notifications/interface';
import {closeNotification, pushNotification}	from '../../redux/notifications/notifications';
import {NotificationCardProps}					from '../components/NotificationCard/interface';
import {DashboardNotification}					from '../../redux/dashboard/interface';
import {LanguageNotification, LanguageType,
	LanguageDashboardNotification,
	BasicNotification}				from '../language/type';

import Icon										from '../components/Icon';

import img_switch								from '../images/icon/switch-horizontal.svg';
import img_calendar								from '../images/icon/calendar-date.svg';
import img_user									from '../images/icon/user.svg';
import img_message								from '../images/icon/message.svg';

export function ft_pushNotification(dispatch: Dispatch, lastId: number, notification: NotificationCardProps) {
	dispatch(pushNotification(notification));

	setTimeout(() => {
		dispatch(closeNotification(lastId + 1));
	}, 5 * 1000);

	return lastId + 1;
}

export function ft_genNotification(TEXTE: LanguageType, notificationName: keyof LanguageNotification, icon: string, name?: string, type?: NotificationsType) {
	const notifData: BasicNotification = TEXTE.notifications[notificationName];
	const text: NotificationText[] = [];
	let title = '';

	if (typeof notifData.messagePart1 === 'string') {
		text.push({text: notifData.messagePart1 || ''});

		if (name)
			text.push({className: 'primary-600 weight-500', text: name});
		if (typeof notifData.messagePart2 === 'string')
			text.push({text: notifData.messagePart2 || ''});
	} else if (name)
		title += name;

	title += TEXTE.notifications[notificationName]?.title;

	const notification: NotificationCardProps = {icon, type, text, title};

	return notification;
}

export function ft_genDashboardNotification(TEXTE: LanguageType, navigate: NavigateFunction, notificationName: keyof LanguageDashboardNotification, vars: DashboardNotification['vars']): React.ReactElement[] {
	const render: React.ReactElement[] = [];

	if (!TEXTE || !notificationName || !TEXTE.dashboardNotification[notificationName])
		return render;

	const notification = TEXTE.dashboardNotification[notificationName];

	for (let i = 0; i < notification.length; i++) {
		const split = notification[i].split(/<b>|<\/b>/);

		split.forEach((text, index) => {
			const textWithSpaces = text.replace(/\s/g, '\u00A0');

			if (index % 2 === 1)
				return render.push(<span key={`${i}-split-${index}`} className={'weight-700'}>{textWithSpaces}</span>);
			render.push(<span key={`${i}-split-${index}`}>{textWithSpaces}</span>);
		});

		if (vars[i]) {
			let link = '';

			if (vars[i].id && vars[i].type)
				link = `/${vars[i].type}/${vars[i].id}`;

			render.push(
				<span
					key={i}
					className={'weight-500 primary-700'}
					onClick={() => link && navigate(link)}
					style={link ? {cursor: 'pointer'} : {}}
				>{vars[i].value}</span>
			);
		}
	}

	return render;
}

export function ft_getDashboardNotificationIcon(notificationName: keyof LanguageDashboardNotification) {
	let img = '';
	let color = 'success-500';

	if (notificationName === 'replacement')
		img = img_switch;
	else if (notificationName === 'end1Month' || notificationName === 'end1Week') {
		img = img_calendar;
		color = 'warning-500';
	} else if (notificationName === 'needReturn') {
		img = img_calendar;
		color = 'error-500';
	} else if (notificationName === 'noDevice' || notificationName === 'newUserNoDevice') {
		img = img_user;
		color = 'warning-500';
	} else if (notificationName === 'sign') {
		img = img_user;
		color = 'error-500';
	} else if (notificationName === 'resolve' || notificationName === 'newMessage')
		img = img_message;

	return (
		<div className={`dashboardNotificationIcon ${color}-background`}>
			<Icon icon={img} iconColor={'#ffffff'} iconSize={12} />
		</div>
	);
}